import Polyglot from 'node-polyglot';
import { GetPreferredLanguage } from './utility';

const languagePreference = GetPreferredLanguage();

const polyglot = new Polyglot({ locale: languagePreference });

const translations = require(`../translations/${polyglot.locale()}.json`);
polyglot.extend(translations);

/**
 * This function is simply a shorthand wrapper for calling polyglot.t(). It is used as L()
 * to keep the function name small, since this will be called all throughout the application.
 * @param {The string to translate} string
 * @param {Interpolation of any values that need to be included in the string} interpolation
 */
function L(string, interpolation) {
  return polyglot.t(string, interpolation);
}

// This does not export default, so that L is required as the function name where used.
// Also so that this can be extended to potentially
// to include some other helper functions in the future.
export {
  L,
  polyglot,
};

export default L;
